import { c as _c } from "react/compiler-runtime";
import React from 'react';
import classNames from 'clsx';
import { ButtonBase } from './ButtonBase';
import { innerSizeClassesMap } from './ButtonClasses';
import { getIconClasses } from './IconClasses';
export const Button = React.forwardRef((t0, ref) => {
  const $ = _c(18);
  let LeadingIcon;
  let props;
  let size;
  let t1;
  if ($[0] !== t0) {
    ({
      leadingIcon: LeadingIcon,
      ...props
    } = t0);
    const {
      color,
      variant,
      size: t2
    } = props;
    size = t2;
    t1 = getIconClasses({
      color,
      variant,
      size
    });
    $[0] = t0;
    $[1] = LeadingIcon;
    $[2] = props;
    $[3] = size;
    $[4] = t1;
  } else {
    LeadingIcon = $[1];
    props = $[2];
    size = $[3];
    t1 = $[4];
  }
  const {
    iconClasses
  } = t1;
  const t2 = innerSizeClassesMap[size];
  let t3;
  if ($[5] !== t2) {
    t3 = classNames("inline-flex flex-row items-center", t2);
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== LeadingIcon || $[8] !== iconClasses) {
    t4 = !!LeadingIcon && <LeadingIcon data-testid="leading-icon" className={iconClasses} />;
    $[7] = LeadingIcon;
    $[8] = iconClasses;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== props.children || $[11] !== t3 || $[12] !== t4) {
    t5 = <span className={t3}>{t4}{props.children}</span>;
    $[10] = props.children;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== props || $[15] !== ref || $[16] !== t5) {
    t6 = <ButtonBase {...props} ref={ref}>{t5}</ButtonBase>;
    $[14] = props;
    $[15] = ref;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  return t6;
});
Button.displayName = 'Button';